import React from "react";
import "../assets/styles/App.scss";

const Projects = () => {
  return <div>Projects</div>;
};

export default Projects;
